import { fonts } from "../../../../styles/fonts";
import { TRANSFORM_FACTORS_COLORS } from "../constants";
import { colors } from "../../../../styles/colors";

const assignPlanWrapper = {
    padding: 30,
    background: "#fafbfc"
}

const tableHeader = {
    color: "rgb(128, 128, 128)",
    fontFamily: fonts.mediumFont,
    fontSize: 13
}

const datesRangeLabel = {
    width: 125,
    color: "rgba(0, 0, 0, 0.87)"
}

const tableOuterWrapper = {
    width: "100%"
}

const divider = {
    borderTop: "1px solid rgb(182, 198, 215)",
    marginTop: 10
}

const plusIcon = (props: any): any => ({
    textAlign: "center",
    cursor: props.isPastWeek && "not-allowed"
})

const circle = (props: any) => ({
    border: "2px solid rgb(151,151,151)",
    display: "inline-block",
    color: "rgb(151,151,151)",
    width: 25,
    height: 25,
    borderRadius: "50%",
    textAlign: "center",
    cursor: "pointer",
    pointerEvents: props.isPastWeek && "none",
    fontSize: 23,
    lineHeight: "25px",
    paddingLeft: 1
})

const factorLabel = {
    ...datesRangeLabel,
    fontFamily: fonts.boldFont,
    fontSize: 16,
    textDecoration: "underline",
    lineHeight: "60px"
}

const actionsWrapper = {
    marginTop: 10,
    display: "flex",
    justifyContent: "flex-end"
}

const buttonStyles = {
    display: "inline",
    fontSize: 14,
    padding: "12px 25px",
    marginTop: "4px",
    fontFamily: fonts.boldFont
}

const columnWrapper = (props: any) => ({
    background: TRANSFORM_FACTORS_COLORS[props.factor],
    padding: 5,
    paddingLeft: 15,
    borderRadius: 10
})

const actions: any = {
    float: "right"
}

const planTitle = {
    color: colors.black,
    fontFamily: fonts.regularFont,
    fontSize: 14
}

const planHeading = {
    fontFamily: fonts.boldFont
}

const deleteIcon = {
    cursor: "pointer",
    marginRight: 10,
    marginLeft: 15
}

const draftLabel = {
    color: "rgb(51, 94, 144)",
    fontFamily: fonts.boldFont,
    fontSize: 14
}


export {
    assignPlanWrapper,
    tableHeader,
    datesRangeLabel,
    tableOuterWrapper,
    divider,
    plusIcon,
    factorLabel,
    circle,
    actionsWrapper,
    buttonStyles,
    columnWrapper,
    actions,
    planHeading,
    planTitle,
    deleteIcon,
    draftLabel
}